import { acctTypes } from "../../../utils/vars";
import { useNavigate } from "react-router-dom";
import { links } from "../../../utils/routes";
import Table from "../../table/Table";
import svg from "../../../utils/svg";
import AccountPreview from "../../AccountPreview";
import useAccounts from "../../../hooks/api/useAccounts";
import urls from "../../../api/urls";
import { useEffect } from "react";

function Creators({ initialLimit }) {
  const navigate = useNavigate();
  const { accounts, getAccounts } = useAccounts({ url: urls.admin.accounts });

  useEffect(() => {
    getAccounts(1, 200, "creator");
  }, []);

  return (
    <div>
      <Table
        btn={
          initialLimit && {
            title: "View All",
            className: "btn-view",
            onClick: () => navigate(links.accounts.list(acctTypes.creator)),
          }
        }
        data={accounts}
        head={[
          ...head,
          {
            title: "Actions",
            target: "id",
            render: (id) => (
              <button
                onClick={() =>
                  navigate(links.accounts.view(acctTypes.creator, id), {
                    state: { data: accounts.filter((a) => a.id == id)[0] },
                  })
                }
                className="action flex align-center"
              >
                {svg.eye()} <span className="f700">VIEW</span>
              </button>
            ),
          },
        ]}
        title="Creators"
      />
    </div>
  );
}

export default Creators;

const head = [
  {
    title: "#",
    target: "#",
    className: "count",
  },
  {
    title: "Name",
    target: ["imageUrl", "firstName", "lastName"],
    render: (value) => (
      <AccountPreview
        user={{
          imageUrl: value[0],
          firstName: value[1],
          lastName: value[2],
        }}
      />
    ),
  },
  {
    title: "Email",
    target: "email",
  },
  {
    title: "Phone Number",
    target: "phoneNumber",
  },
  {
    title: "Active",
    target: "isActive",
    render: (value) => (
      <span className={`status ${value}`}>
        {value.toString().toUpperCase()}
      </span>
    ),
  },
];
